import { useEffect, useState } from "react";
import FormComp from "../../../Componentes/FormComp";
import Formulario from "../../../Componentes/Utils/Formulario";
import Overlay from "../../../Componentes/Overlay"
import Modal from "../../../Componentes/Utils/Modal"
import { useModal } from "../../../contexts/ModalContext";
import axios from "axios";
import SmallLoading from "../../../Componentes/Utils/SmallLoading";
import { set } from "date-fns";

const ModalAddChecklist = ({ fetchSuccess }) => {

    const { closeModal } = useModal();

    const [loading, setLoading] = useState(true);

    const [listaCC, setListaCC] = useState([]);
    const [listaContratos, setListaContratos] = useState([])
    const [listaTipos, setListaTipos] = useState([]);
    const [listaModelos, setListaModelos] = useState([]);
    const [listaFamilias, setListaFamilias] = useState([]);
    const [listaEquipamentos, setListaEquipamentos] = useState([]);
    const [listaAreas, setListaAreas] = useState([]);

    const fetchInit = async () => {

        setLoading(true);

        try {

            const [resTipos, resCentroCusto] = await Promise.all([
                axios.get("https://sistemaintegrado.palmont.com.br/Painel/API/Checklist/GetTipos/"),
                axios.get("https://sistemaintegrado.palmont.com.br/Painel/API/GetObrasAtivas/")
            ]);

            setListaTipos(resTipos.data);
            setListaCC(resCentroCusto.data.map(obj => obj.OBRA));

        } catch (e) {

            console.error(e);

        } finally {

            setLoading(false);

        }

    }

    useEffect(() => {
        fetchInit();
    }, [])

    const [formValues, setFormValues] = useState({
        tipo: "",
        modelo: "",
        familia: "",
        equipamentoID: "",
        data: "",
        centroCusto: "",
        contrato: "",
        area: "",
        auditadoMat: "",
        auditadoName: "",
        equipe: "",
        lider: "",
        liderMat: ""
    })

    const handleChange = (e, name) => {

        let { value } = e.target;

        if (name === 'auditadoMat') {
            value = value.replace(/\D/g, "");
        }

        setFormValues((prev) => ({
            ...prev,
            [name]: value
        }))

    }

    useEffect(() => {

        setFormValues((prev) => ({
            ...prev,
            modelo: ""
        }))

        if (formValues.tipo === "") {

            setListaModelos([]);
            return;

        }

        const fetchModelos = async () => {
            setLoading(true);
            try {
                const { data } = await axios.get(`https://sistemaintegrado.palmont.com.br/Painel/API/Checklist/GetModelos/index.php?tipoId=${formValues.tipo}`)
                setListaModelos(data)
            } catch (e) {
                console.error(e);
            } finally {
                setLoading(false);
            }
        }

        const tipo = listaTipos.find(obj => obj.identifier === formValues.tipo)
        if (tipo?.modelos === 1) {
            fetchModelos();
        } else {
            setListaModelos([]);
        }

    }, [formValues.tipo, listaTipos])

    useEffect(() => {

        setFormValues((prev) => ({
            ...prev,
            familia: ""
        }))

        if (formValues.modelo === "") {
            setListaFamilias([]);
            return;
        }

        const fetchEquipamentos = async () => {
            setLoading(true);

            try {
                const { data } = await axios.get('https://sistemaintegrado.palmont.com.br/Painel/API/Checklist/GetEquipamentosFamily/');
                setListaFamilias(data);
            } catch (e) {
                console.error(e);
            } finally {
                setLoading(false);
            }
        }

        const familiasTipo = listaModelos.find(obj => obj.identifier === formValues.modelo);
        const canHaveEquipamento = familiasTipo?.equipamento === 1;

        if (canHaveEquipamento) {
            fetchEquipamentos();
        } else {
            setListaFamilias([]);
        }

    }, [formValues.modelo])

    useEffect(() => {

        setFormValues((prev) => ({
            ...prev,
            equipamentoID: ""
        }))

        if (formValues.familia === "") {
            setListaEquipamentos([]);
            return;
        }

        const fetchEquipamentosID = async () => {

            setLoading(true);

            try {

                const { data } = await axios.get(`https://sistemaintegrado.palmont.com.br/Painel/API/Checklist/GetEquipamentosId/index.php?familia=${formValues.familia}`);
                setListaEquipamentos(data);
            } catch (e) {
                console.error(e);
            } finally {
                setLoading(false);
            }

        }

        fetchEquipamentosID();

    }, [formValues.familia])

    useEffect(() => {

        setFormValues((prev) => ({
            ...prev,
            contrato: ""
        }))

        if (formValues.centroCusto === "") {
            setListaContratos([]);
            return;
        }

        const fetchContratos = async () => {
            setLoading(true);
            try {
                const { data } = await axios.post("https://sistemaintegrado.palmont.com.br/Painel/API/GetContratosObra/", {
                    "centro_custo": formValues.centroCusto
                })
                setListaContratos(data.map(obj => obj.nome_contrato));
            } catch (e) {
                console.error(e);
            } finally {
                setLoading(false);
            }
        }

        fetchContratos();
    }, [formValues.centroCusto])

    useEffect(() => {

        setFormValues((prev) => ({
            ...prev,
            area: ""
        }))

        if (formValues.contrato === '') {
            setListaAreas([]);
            return;
        }

        const fetchAreas = async () => {

            setLoading(true);
            try {
                const { data } = await axios.post('https://sistemaintegrado.palmont.com.br/Painel/API/GetListaAreas/', {
                    "centroCusto": formValues.centroCusto,
                    "contrato": formValues.contrato
                })
                setListaAreas(data);
            } catch (e) {
                console.error(e)
            } finally {
                setLoading(false);
            }

        }

        fetchAreas();

    }, [formValues.contrato])

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (formValues.auditadoMat.length !== 6) {
            return;
        }

        setLoading(true);

        try {

            await axios.post('https://sistemaintegrado.palmont.com.br/Painel/API/Checklist/SaveNewChecklist/', formValues, {
                withCredentials: true
            })

            await fetchSuccess?.();
            closeModal();

        } catch (e) {

            console.error(e);

        } finally {

            setLoading(false);

        }
    }

    useEffect(() => {

        const fetchInfoColab = async () => {
            setLoading(true);
            try {
                const { data } = await axios.post(`https://sistemaintegrado.palmont.com.br/Painel/API/Checklist/GetColabInfo/index.php?matricula=${formValues.auditadoMat}`, {
                    matricula: formValues.auditadoMat
                })
                console.log(data);
                setFormValues((prev) => ({
                    ...prev,
                    auditadoName: data.NOME,
                    lider: data.LIDER_NOME,
                    liderMat: data.LIDER_MAT,
                    equipe: data.EQUIPE
                }))
            } catch (e) {
                console.error(e);
            } finally {
                setLoading(false);
            }
        }

        if (formValues.auditadoMat.length === 6) {

            fetchInfoColab();

        } else {

            setFormValues((prev) => ({
                ...prev,
                auditadoName: '',
                lider: '',
                liderMat: '',
                equipe: ''
            }))

        }

    }, [formValues.auditadoMat])

    useEffect(() => {

        console.log(formValues);

    }, [formValues])

    return (
        <Overlay state={true} >
            <Modal header={true} close={closeModal} >
                <Formulario onSubmit={(e) => handleSubmit(e)} >
                    <FormComp
                        title="TIPO DE CHECKLIST"
                        type="select"
                        options={listaTipos.map((obj) => (
                            <option key={obj.identifier} value={obj.identifier} >{obj.nome}</option>
                        ))}
                        mapped={true}
                        valor={formValues.tipo}
                        changeFunc={(e) => handleChange(e, 'tipo')}
                        required={true}
                    />
                    {listaModelos.length > 0 && (
                        <FormComp
                            title="MODELO CHECKLIST"
                            type="select"
                            options={listaModelos.map((obj) => (
                                <option key={obj.identifier} value={obj.identifier} >{obj.nome}</option>
                            ))}
                            mapped={true}
                            valor={formValues.modelo}
                            changeFunc={(e) => handleChange(e, 'modelo')}
                            required={listaModelos.length > 0}
                        />
                    )}
                    {listaFamilias.length > 0 && (
                        <FormComp
                            title="FAMÍLIA EQUIPAMENTO"
                            type="select"
                            options={listaFamilias.map((obj) => (
                                <option key={obj.FAMILIA} value={obj.FAMILIA} >{obj.DESCRICAO}</option>
                            ))}
                            mapped={true}
                            valor={formValues.familia}
                            changeFunc={(e) => handleChange(e, 'familia')}
                            required={listaFamilias.length > 0}
                        />
                    )}
                    {listaEquipamentos.length > 0 && (
                        <FormComp
                            title="EQUIPAMENTO"
                            type="select"
                            options={listaEquipamentos.map((obj) => (
                                <option key={obj.CODIGO} value={obj.CODIGO} >{obj.CODIGO}</option>
                            ))}
                            mapped={true}
                            valor={formValues.equipamentoID}
                            changeFunc={(e) => handleChange(e, 'equipamentoID')}
                            required={listaEquipamentos.length > 0}
                        />
                    )}
                    <FormComp
                        title="DATA"
                        type="date"
                        valor={formValues.data}
                        changeFunc={(e) => handleChange(e, 'data')}
                        required={true}
                    />
                    <FormComp
                        title="CENTRO CUSTO"
                        type="select"
                        options={listaCC}
                        valor={formValues.centroCusto}
                        changeFunc={(e) => handleChange(e, 'centroCusto')}
                        required={true}
                    />
                    <FormComp
                        title="CONTRATO"
                        type="select"
                        options={listaContratos}
                        valor={formValues.contrato}
                        changeFunc={(e) => handleChange(e, 'contrato')}
                        required={true}
                    />
                    <FormComp
                        title="ÁREA"
                        type="select"
                        options={listaAreas}
                        valor={formValues.area}
                        changeFunc={(e) => handleChange(e, 'area')}
                        required={true}
                    />
                    <FormComp
                        title="MATRICULA AUDITADO"
                        type="text"
                        maxLength={6}
                        valor={formValues.auditadoMat}
                        changeFunc={(e) => handleChange(e, 'auditadoMat')}
                        required={true}
                    />
                    <FormComp
                        title="NOME AUDITADO"
                        type="text"
                        readOnly
                        valor={formValues.auditadoName}
                        required={true}
                    />
                    <FormComp
                        title="EQUIPE"
                        type="text"
                        readOnly
                        valor={formValues.equipe}
                        required={true}
                    />
                    <FormComp
                        title="LÍDER"
                        type="text"
                        readOnly
                        valor={formValues.lider}
                        required={true}
                    />
                    <FormComp
                        type="submit"
                        valor="SALVAR"
                    />
                </Formulario>
            </Modal>
            {loading && (
                <Overlay state={true} >
                    <Modal size="sm" >
                        <SmallLoading />
                    </Modal>
                </Overlay>
            )}
        </Overlay>
    )
}

export default ModalAddChecklist;